module.exports = __webpack_public_path__ + "img/band2.21c8c21c.png";